/**
 * ProfileUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ProfileUpdateReq
 */
export interface ProfileUpdateReq {
  /** 昵称 */
  nickname?: string
  /** 简介 */
  bio?: string
}

/**
 * ProfileUpdateReq Schema
 */
export const ProfileUpdateReqSchema: SchemaDefinition = {
  properties: {
    nickname: {
      description: '昵称',
      format: '*string',
      maxLength: 50,
      type: 'string',
      label: '昵称',
    },
    bio: {
      description: '简介',
      format: '*string',
      maxLength: 500,
      type: 'string',
      label: '简介',
    },
  },
  type: 'object',
}
